export const SELECT_ALL_OPTIONS_LIMIT = 500;

type SelectableOption = { value?: string | null };

export const canSelectAll = (visibleOptionsCount: number) => visibleOptionsCount <= SELECT_ALL_OPTIONS_LIMIT;

export const toggleValue = (current: string[] = [], optionValue: string, checked: boolean) =>
  checked ? [...current, optionValue] : current.filter((v) => v !== optionValue);

export const selectAllValues = (current: string[] = [], visibleOptions: SelectableOption[]) => {
  const values = new Set(current);
  for (const option of visibleOptions) {
    if (option.value) values.add(option.value);
  }
  return Array.from(values);
};

export const hasSelection = (current: string[] = [], visibleOptions: SelectableOption[]) =>
  visibleOptions.some((o) => !!o.value && current.includes(o.value));

export const clearValues = (current: string[] = [], visibleOptions: SelectableOption[]) => {
  const toRemove = new Set(visibleOptions.map((o) => o.value).filter(Boolean));
  return current.filter((v) => !toRemove.has(v));
};
